import { LocationOn, Store } from "@mui/icons-material";
import { constructTitles } from "./compactView";
import { getTodayOrDate } from "./functions";
import { HtmlTooltip } from "./tooltip";
import { IProps, TStoreAvailability } from "./types";

const PopupView: React.FC<IProps> = (props) => {
  const { avails } = props;

  return <>
    {avails.map((avail: TStoreAvailability) => {
      return <div className='avail-compact-view-item'>
        <div className='highlighter cell'>{avail.storeQty}</div>
        <div className='cell'>
          {getTodayOrDate(avail)}
        </div>
        <div className='cell'>
          {avail.deliveredByDesc.replace('Delivered by', '')}
        </div>
        <div className='cell'>
          {avail.stores.length > 1 ? <HtmlTooltip title={constructTitles(avail.stores)}>
            <div className='link'>
              <Store color='error' fontSize='small' /> {`${avail.stores[0].store}`} - <LocationOn color='error' fontSize='small' /> {`${avail.stores[0].address}`}
            </div>
          </HtmlTooltip> : <><Store color='error' fontSize='small' /> {`${avail.store}`} - <LocationOn color='error' fontSize='small' /> {`${avail.address}`}</>}
        </div>
      </div>
    }
    )}
  </>
};

export default PopupView;
